export const initialState = {
  projectToEdit: null,
};

export function FETCH_PROJECT_TO_EDIT_NORMALIZATION(nextState, { result }) {
  nextState.projectToEdit = result;
}
